module.exports = "https://cdn.hellotech.com/client-assets/orange-triangle_a5779f5773b26ac0d8251d05dc9cbe0e.png";